<template>
  <div class="leftTwo">
    <commonHeader title="手动趋势统计"></commonHeader>
    <ul class="tab">
      <li
        v-for="(item, index) in tabList"
        :key="index"
        :class="{ active: currentTab === item.value }"
        @click="changeTab(item)"
      >
        {{ item.name }}
      </li>
    </ul>
    <div class="charts" id="charts" v-if="chartsData.xAxis.length > 0">
      <LineChart :chartData="chartsData" id="lineChart" :name="nameArr" />
    </div>
    <div class="charts" v-else>
      <div class="no-data">暂无数据</div>
    </div>
  </div>
</template>

<script>
  import commonHeader from '../commonHeader.vue'
  import LineChart from './lineChart.vue'
  export default {
    name: 'leftTwo',
    props: {
      areaId: {
        type: Number | String
      }
    },
    components: {
      commonHeader,
      LineChart
    },
    data() {
      return {
        currentTab: 'day',
        tabList: [
          {
            value: 'day',
            name: '日'
          },
          {
            value: 'month',
            name: '月'
          },
          {
            value: 'year',
            name: '年'
          }
        ],
        chartsData: {
          xAxis: [],
          yAxis: {
            data1: [],
            data2: []
          }
        },
        nameArr: ['今日', '昨日'],
        dateType: {
          day: 0,
          month: 1,
          year: 2
        },
        nameTypeArr: {
          day: ['今日', '昨日'],
          month: ['本月', '上月'],
          year: ['今年', '去年']
        },
        timer: null
      }
    },
    watch: {
      areaId: {
        handler(val) {
          this.currentTab = 'day'
          this.getData()
          this.startTimer()
        },
        immediate: true
      }
    },
    methods: {
      changeTab(item) {
        this.currentTab = item.value
        this.getData()
      },
      getData() {
        this.$axiospost('operation/automatic/hand/detection/queryLeftTwoStatics', {
          parentAreaId: this.areaId,
          dateType: this.dateType[this.currentTab]
        }).then(res => {
          if (res.data.status == 10000) {
            this.nameArr = this.nameTypeArr[this.currentTab]
            this.chartsData.xAxis =
              res.data.data.length > 0 ? res.data.data.map(item => item.areaName) : []
            this.chartsData.yAxis.data1 =
              res.data.data.length > 0 ? res.data.data.map(item => item.count) : []
            this.chartsData.yAxis.data2 =
              res.data.data.length > 0 ? res.data.data.map(item => item.lastCount) : []
          }
        })
      },
      // 新增：启动定时器
      startTimer() {
        this.stopTimer() // 先清除可能存在的定时器
        this.timer = setInterval(() => {
          this.getData()
        }, 5 * 60 * 1000) // 5分钟 = 300000毫秒
      },
      // 新增：停止定时器
      stopTimer() {
        if (this.timer) {
          clearInterval(this.timer)
          this.timer = null
        }
      }
    },
    beforeDestroy() {
      clearInterval(this.stopTimer)
    }
  }
</script>

<style lang="less" scoped>
  .leftTwo {
    height: 29.5vh;
    position: relative;

    .tab {
      position: absolute;
      right: 0;
      top: 3.7vh;
      display: flex;
      align-items: center;
      border-radius: 0.03rem;
      background: #05264b;

      li {
        width: 0.4rem;
        height: 1.94vh;
        border: 1px solid #2d5fbb;
        text-align: center;
        line-height: 1.94vh;
        font-family: AdobeHeitiStd-Regular;
        font-size: 1.3vh;
        color: #b3ccff;
        cursor: pointer;

        &:nth-child(2) {
          border-radius: 0;
        }

        &.active {
          box-shadow: inset 0 0 0.1rem #42cdc2;
          border-color: #42cdc2;
          color: #4fd3cc;
        }
      }
    }

    .charts {
      margin-left: 0.18rem;
      height: 22vh;
      margin-top: 2vh;

      .no-data {
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 1.3vh;
        color: rgba(255, 255, 255, 0.6);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pumpMonitor/leftTwo/index.vue